import Vue from 'vue';
import App from './App.vue';
import ElementUI from 'element-ui';
import router from './plugins/router';
import axios from './plugins/request';
import dic from './plugins/dic.js';
import moment from 'moment';
import './style/config.css';
import './style/theme/index.css';
import PageGroup from "./common/PageGroup.vue"

ElementUI.TableColumn.props.showOverflowTooltip = { type: Boolean, default: true }
Vue.use(ElementUI);
Vue.use(PageGroup);
Vue.component('el-pagegroup', PageGroup)
Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.prototype.$dic = dic;

new Vue({
    router,
    render: h => h(App)
}).$mount('#app');

//本地存储一个对象
Vue.prototype.$setStorage = function(key, obj) {
    if (typeof obj === 'string') {
        localStorage.setItem(key, obj);
    } else {
        localStorage.setItem(key, JSON.stringify(obj));
    }
}

//本地获取一个对象
Vue.prototype.$getStorage = function(key) {
    let val = localStorage.getItem(key);
    try {
        return JSON.parse(val);
    } catch (e) {
        return val;
    }
}

//本地清空一个对象
Vue.prototype.$clearStorage = function(key) {
    if (key) {
        localStorage.removeItem(key);
    } else {
        localStorage.clear();
    }
}

Vue.prototype.$coldate = function(row, column) {
    let date = row[column.property];
    if (date == undefined) {
        return ''
    }
    return moment(date).format("YYYY-MM-DD")
}

Vue.prototype.$transdate = function(str) {
    return moment(str).format("YYYY-MM-DD")
}

Vue.prototype.$transtime = function(str) {
    return moment(str).format("YYYY-MM-DD HH:mm:ss")
}


Vue.prototype.$transyear = function(str) {
    return moment(str).format("DD")
}

Vue.prototype.$transday = function(str) {
    return moment(str).format("YYYY-MM月")
}